import { render } from "./ReqError.vue?vue&type=template&id=7c927a2c&scoped=true"
const script = {}

import "./ReqError.vue?vue&type=style&index=0&id=7c927a2c&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c927a2c"]])

export default __exports__